import React from 'react';

const PerfilCards = ({ perfiles, onSelect, t }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
    {perfiles.map(perfil => (
      <div
        key={perfil.id}
        className="cursor-pointer p-4 shadow rounded-xl border bg-white hover:bg-gray-100"
        onClick={() => onSelect(perfil)}
      >
        <h2 className="text-xl font-semibold text-center">
          {t ? t(`labels.${perfil.nombre}`, perfil.nombre) : perfil.nombre}
        </h2>
      </div>
    ))}
  </div>
);

export default PerfilCards;
